<template>
    <div class="review-agent-notes">
        <div class="panel" boxed>
            <div class="review--title--small">Osservazioni importanti dal tuo consulente di viaggio:</div>
            <div class="tiny-mce italic" v-html="agent_notes"></div>
        </div>        
    </div>
</template>


<script>
    export default {
        name: 'review-agent-notes',
        components: {
        },
        props:
        {
            agent_notes: {
                type: String,
                default: '',
            },
        },
        created()
        {
        },
        data() {
            return {
            }
        },
        computed: {
        },
        mounted() {
        },
        methods:{
        },
    }
</script>

<style lang="scss">
    .review-agent-notes
    {
        margin:2rem 0;
        .panel
        {
            border-radius:20px;
            border:1px dashed #39414e;
            font-size: 14px;
        }
        p:last-child
        {
            margin-bottom:0;
        }
        &--title
        {
        }
        .review--title--small
        {
            font-size: 15px;
            margin-bottom:1rem;
        }
    }
    .review--block .review-agent-notes
    {
        margin:0 0 2rem 0;
    }
</style>